import { useTranslation } from 'react-i18next';
import { getRussianDayPlural } from '../utils';

export const useRussianDayPlural = () => {
  const { t, i18n } = useTranslation();

  const getDayPlural = (count: number): string => {
    if (i18n.language === 'ru' || i18n.language.startsWith('ru')) {
      return getRussianDayPlural(count);
    }

    return t('count-day-trial', { count });
  };

  return { getDayPlural };
};
